shouldRetry